/**
 * Formatting utilities for the Analytics page
 */

/**
 * Format a timestamp to a readable time string (HH:MM)
 *
 * @param timestamp - Unix timestamp in milliseconds
 * @returns Formatted time string (e.g., "14:30")
 */
export const formatTime = (timestamp: number): string => {
  const date = new Date(timestamp)
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
}

/**
 * Format a number without trailing zeros
 * Useful for displaying harvest quantities (e.g., 5.5 boxes, 10 boxes)
 *
 * @param num - Number to format
 * @returns Formatted string without trailing zeros
 *
 * @example
 * formatNumber(5.5)  // "5.5"
 * formatNumber(10.0) // "10"
 * formatNumber(3.20) // "3.2"
 */
export const formatNumber = (num: number): string => {
  return num.toFixed(2).replace(/\.?0+$/, '')
}

/**
 * Get initials from first and last name
 *
 * @param firstName - Worker's first name
 * @param lastName - Worker's last name
 * @returns Two-letter initials in uppercase
 *
 * @example
 * getInitials("John", "Doe") // "JD"
 */
export const getInitials = (firstName: string, lastName: string): string => {
  return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase()
}
